import React from 'react';
interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  icon?: React.ReactNode;
  className?: string;
}
const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  onClick,
  type = 'button',
  disabled = false,
  icon,
  className = ''
}) => {
  const baseClasses = 'rounded-xl font-medium transition-all duration-200 flex items-center justify-center';
  const variantClasses = {
    primary: 'bg-gradient-to-r from-teal-500 to-cyan-400 hover:from-teal-600 hover:to-cyan-500 text-white shadow-md hover:shadow-lg active:shadow',
    secondary: 'bg-gradient-to-r from-orange-500 to-amber-400 hover:from-orange-600 hover:to-amber-500 text-white shadow-md hover:shadow-lg active:shadow',
    outline: 'border-2 border-teal-500 dark:border-teal-400 text-teal-500 dark:text-teal-400 hover:bg-teal-50 dark:hover:bg-teal-900/30',
    ghost: 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
  };
  const sizeClasses = {
    sm: 'text-sm py-1.5 px-3 gap-1.5',
    md: 'text-base py-2.5 px-5 gap-2',
    lg: 'text-lg py-3 px-6 gap-2.5'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const disabledClass = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';
  return <button type={type} onClick={onClick} disabled={disabled} className={`
        ${baseClasses} 
        ${variantClasses[variant]} 
        ${sizeClasses[size]} 
        ${widthClass} 
        ${disabledClass}
        ${className}
      `} data-id="element-44">
      {icon && <span className="button-icon" data-id="element-45">{icon}</span>}
      {children}
    </button>;
};
export default Button;